import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { injectGlobal } from '@emotion/css';
import { useTheme, Global, css } from '@emotion/react';
import { useEffect } from 'react';
import reset from './reset.js';
import global from './global.js';
import common from './common.js';
import { fontURL } from './fonts.js';
import animations from './animations.js';
import { initTheme } from '../theme/index.js';
const theme = initTheme();
export const GlobalStylesProvider = ({ children }) => {
    const theme = useTheme();
    useEffect(() => {
        injectGlobal `@import url(${fontURL});`;
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(Global, { styles: css `
          ${reset}
          ${global}
          ${common(theme)}
          ${animations}
        ` }), children] }));
};
export const attachGlobalStyles = () => injectGlobal `
    @import url(${fontURL});
    ${reset}
    ${global}
    ${common(theme)}
    ${animations}
`;
//# sourceMappingURL=index.js.map